import { LEVELS_COMPLETED_KEY, SAVED_GAME_KEY, PRACTICE, COMPETE, STATS_KEY } from './const';
import { SKILL_PAGE, GAME_PAGE } from '../HOME/const';
import { dbget, dbdel, dbset } from '../HOME/utils';

export function levelInfo(level) {
  switch (level.toString()) {
    default:
    case '1':
      return { name: 'MODERATE', time: 100, color: 'rgb(0,106,0)' };
    case '2':
      return { name: 'FAST', time: 80, color: 'rgb(0,0,106)' };
    case '3':
      return { name: 'SUPERFAST', time: 50, color: 'rgb(106,0,0)' };
    case '4':
      return { name: 'BREAKNECK', time: 30, color: 'rgb(255,106,0)' };
  }
}

export function onCompete(props, board) {
  props.setMode(COMPETE);

  dbget(LEVELS_COMPLETED_KEY, level => {
    props.setLevelsCompleted(level > 0 ? level : 0);

    dbget(SAVED_GAME_KEY, game => {
      if (!board && props.board) {
        board = props.board.current;
      }

      if (game) {
        const { hits, misses, score, level, startLevel } = game;

        props.setScore(hits, misses, score);
        props.setLevel(level);
        props.setStartLevel(startLevel);
        props.setIntroduced(true);
        props.setLoadingGame(true);

        if (props.page === GAME_PAGE) {
          board.newSet();
          board.handleCompete();
        } else {
          props.goToPage(GAME_PAGE);
        }
      } else if (level > 0) {
        props.goToPage(SKILL_PAGE);
      } else if (props.mode === PRACTICE) {
        props.setIntroduced(false);
        board.handleCompete();
      } else {
        props.goToPage(GAME_PAGE);
      }
    });
  });
}

export function onGameOver(props) {
  dbdel(SAVED_GAME_KEY);

  let { stats } = props;

  if (!stats) {
    stats = { plays: 0, aggScore: 0, best: 0 };
  }

  const plays = stats.plays + 1;
  const aggScore = stats.aggScore + props.score;
  const best = props.score > stats.best ? props.score : stats.best;

  dbset(STATS_KEY, { plays, aggScore, best });
  props.updateStats(plays, aggScore, best);
}

export function initStats(props) {
  let { stats } = props;

  if (!stats) {
    stats = { plays: 0, aggScore: 0, best: 0 };
  }

  const { plays, aggScore, best } = stats;
  props.updateStats(plays, aggScore, best);
}
